var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14804_76646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V45H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V13.5H0V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31.5H60V45H0V31.5Z",
    fill: "#006600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9561 35.8594L22.4623 36.1406L35.5967 13.3594C36.3561 13.1906 36.7779 12.4594 37.1998 11.7281C37.4811 11.2219 38.6061 9.28125 39.0842 6.75C37.7499 7.93572 36.6192 9.33241 35.7373 10.8844C35.3154 11.6156 34.8936 12.3469 35.0904 13.1062L21.9561 35.8594Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2988 6.37109L39.2223 6.77609C38.7595 9.22597 37.697 11.1266 37.3618 11.7262C37.3474 11.752 37.3343 11.7755 37.3226 11.7964L37.3221 11.7974L37.3178 11.8049C37.1095 12.1659 36.8931 12.5409 36.6315 12.8462C36.3793 13.1403 36.0777 13.3789 35.6883 13.4818L22.5149 36.3308L21.7627 35.9129L34.9405 13.0846C34.8523 12.6886 34.9164 12.3048 35.0495 11.9369C35.1873 11.5561 35.4034 11.1815 35.6119 10.8201L35.6149 10.8149C35.615 10.8148 35.6151 10.8146 35.6152 10.8145C36.5046 9.2493 37.645 7.84072 38.9907 6.64488L39.2988 6.37109ZM38.8592 7.14565C37.6742 8.25655 36.6628 9.54023 35.8595 10.9538L35.859 10.9546C35.6467 11.3227 35.4426 11.6773 35.314 12.0326C35.1863 12.3854 35.1375 12.7277 35.2265 13.071L35.2409 13.1267L22.1492 35.8059L22.4095 35.9505L35.5057 13.2355L35.5661 13.2221C35.9062 13.1465 36.1769 12.9444 36.4179 12.6632C36.6607 12.3799 36.8651 12.0267 37.0773 11.6589C37.0887 11.6384 37.1015 11.6155 37.1155 11.5905C37.4284 11.0306 38.3705 9.34492 38.8592 7.14565Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9561 35.8594L22.4623 36.1406L35.5967 13.3594C36.3561 13.1906 36.7779 12.4594 37.1998 11.7281C37.4811 11.2219 38.6061 9.28125 39.0842 6.75C37.7499 7.93572 36.6192 9.33241 35.7373 10.8844C35.3154 11.6156 34.8936 12.3469 35.0904 13.1062L21.9561 35.8594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0471 15.75H35.3439C34.5002 13.5 31.6877 9 30.0002 9C28.3127 9 25.5002 13.5 24.6564 15.75H-0.0185547V29.25H24.6564C25.5002 31.5 28.3127 36 30.0002 36C31.6877 36 34.5002 31.5 35.3439 29.25H60.0471V15.75Z",
    fill: "#BB0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3438 29.25C36.1875 27 36.75 24.75 36.75 22.5C36.75 20.25 36.1875 18 35.3438 15.75C34.5 18 33.9375 20.25 33.9375 22.5C33.9375 24.75 34.5 27 35.3438 29.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 24.1875C30.6213 24.1875 31.125 23.432 31.125 22.5C31.125 21.568 30.6213 20.8125 30 20.8125C29.3787 20.8125 28.875 21.568 28.875 22.5C28.875 23.432 29.3787 24.1875 30 24.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2812 24.1312C30.2812 24.1312 31.4062 26.3812 31.4062 30.0375C31.4062 33.6937 30.2812 35.9437 30.2812 35.9437V24.1312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14804_76646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSw);
export default __webpack_public_path__ + "static/media/sw.1d81496c05f0f045c036b6b1305af831.svg";
export { ForwardRef as ReactComponent };